import React from 'react';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { numberFormat } from '../../utils/helpers';
function ShippingMethodsRadioGroup(props) {
    var _a, _b;
    const { methods, setShippingPrice, selectedNurseries } = props;
    const [indexValue, setIndexValue] = React.useState(0);
    const value = (_b = (_a = methods[indexValue]) === null || _a === void 0 ? void 0 : _a.service_name) !== null && _b !== void 0 ? _b : '';
    React.useEffect(() => {
        setIndexValue(0);
    }, [methods]);
    React.useEffect(() => {
        if (selectedNurseries !== 1)
            setIndexValue(0);
    }, [selectedNurseries]);
    React.useEffect(() => {
        if (methods[indexValue]) {
            setShippingPrice(methods[indexValue].total_price / 100, indexValue);
        }
    }, [methods, indexValue, setShippingPrice]);
    function handleChange(event) {
        const nextIndex = methods.findIndex((method) => method.service_name === event.target.value);
        if (nextIndex >= 0)
            setIndexValue(nextIndex);
    }
    return (React.createElement(Grid, { container: true, sx: { pt: 3 } },
        React.createElement(RadioGroup, { "aria-label": value, name: value, value: value, onChange: handleChange }, methods === null || methods === void 0 ? void 0 : methods.map((method, index) => {
            const disabled = methods.length > 1 && selectedNurseries > 1 && index !== 0;
            let serviceLabel = `${method.service_name} - $${numberFormat(method.total_price / 100)}`;
            if (disabled) {
                serviceLabel = (React.createElement(React.Fragment, null,
                    React.createElement("b", null,
                        method.service_name,
                        ' ',
                        "- $",
                        numberFormat(method.total_price / 100)),
                    React.createElement("br", null),
                    "UNAVAILABLE: the lowest priced option will automatically be applied when cart contains plants from mulltiple nurseries"));
            }
            return (React.createElement(FormControlLabel, { disabled: disabled, key: method.service_name, value: method.service_name, control: React.createElement(Radio, { disabled: disabled, sx: { '&.Mui-disabled': { pt: 0 } }, disableRipple: true, size: "small" }), label: serviceLabel, sx: {
                    alignItems: disabled ? 'flex-start' : 'center',
                    '& .MuiFormControlLabel-label': {
                        fontSize: 14,
                        color: 'blueColors.main',
                        lineHeight: '18px',
                        whiteSpace: 'pre-line',
                        textAlign: 'left',
                        '&.Mui-disabled': { color: 'blueColors.main' },
                    },
                } }));
        }))));
}
export default ShippingMethodsRadioGroup;
